export type ImageSubmitActionType = {
  useAsNext: boolean;
};
export class SetImageAction {
  static readonly type = '[SetImageAction] Set Image Action';
  constructor(public payload: ImageSubmitActionType) {}
}
